var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99286 19C10.2555 19.0022 10.5085 18.9013 10.6974 18.7188L16.7068 12.7082C16.8945 12.5204 17 12.2656 17 12C17 11.7344 16.8945 11.4796 16.7068 11.2918L10.6974 5.28121C10.5085 5.09873 10.2555 4.99776 9.99286 5.00004C9.73026 5.00232 9.47905 5.10767 9.29335 5.29341C9.10765 5.47914 9.00232 5.7304 9.00004 5.99305C8.99776 6.25571 9.09871 6.50876 9.28115 6.69769L14.5824 12L13.5809 13.0018L9.28115 17.3023C9.09871 17.4912 8.99776 17.7443 9.00004 18.0069C9.00232 18.2696 9.10765 18.5209 9.29335 18.7066C9.47905 18.8923 9.73026 18.9977 9.99286 19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMd);
export default __webpack_public_path__ + "static/media/right-md.3e9c4679b1061954c140a82f1d634a94.svg";
export { ForwardRef as ReactComponent };